<template>
  <div class="bg-contain bg-center bg-no-repeat animate-spin" :style="styles" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  size: number
  white?: boolean
}>()

const styles = computed(() => {
  const path = props.white
    ? new URL('../../assets/images/SpinnerWhite.png', import.meta.url).href
    : new URL('../../assets/images/SpinnerGray.png', import.meta.url).href

  return {
    backgroundImage: `url("${path}")`,
    width: `${props.size}px`,
    height: `${props.size}px`,
  }
})
</script>
